import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { IMetric } from '@src/emp-3.0/types';
import { METRIC_LIST_QUERY_KEY } from '../constants';
import { getMetricList } from './query';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';

export const useGetMetricList = (preferredVersion?: string): UseQueryResult<IMetric[], unknown> => {
  const { workbenchMode } = useInitialInfoStore();
  return useQuery([METRIC_LIST_QUERY_KEY, workbenchMode, preferredVersion], async () => {
    const res = await getMetricList(preferredVersion);
    return res?.data?.data;
  });
};
